import styled from 'styled-components';

const ButtonDiv = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 14px;
`;

export default ButtonDiv;
